import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToTopBtn = document.getElementById('scroll-to-top-btn');
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.scrollToTopBtn.addEventListener('click', this.scrollToTop.bind(this));
  }

  handleScroll() {
    if (window.scrollY > window.innerHeight * 2) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.scrollToTopBtn.classList.remove('invisible', 'opacity-0', 'translate-y-2');
    this.scrollToTopBtn.classList.add('opacity-100', 'translate-y-0');
  }

  hide() {
    this.scrollToTopBtn.classList.add('invisible', 'opacity-0', 'translate-y-2');
    this.scrollToTopBtn.classList.remove('opacity-100', 'translate-y-0');
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}
